import { Property } from '@app/react-common/components/rule-engine-v2/models/RuleEngineConfig';
import { AbTestTypeCategory } from '../../../models/AbTestCreationType';
import { SHIPPING_RATES_RULES, EXTENSIONS_RULES } from '@app/react-common/utils/RulesByFeatureType';

export interface RulesByTestType {
  [AbTestTypeCategory.SHIPPING_RATES]: Property[];
  [AbTestTypeCategory.EXTENSIONS]: Property[];
  [AbTestTypeCategory.CROSS_SITE]: Property[];
  [AbTestTypeCategory.PRODUCT_PAGE]: Property[];
}

// Theme tests (Cross-Site and Product Page) don't use rules
const CROSS_SITE_RULES: Property[] = [];
const PRODUCT_PAGE_RULES: Property[] = [];

export const RULES_BY_TEST_TYPE: RulesByTestType = {
  [AbTestTypeCategory.SHIPPING_RATES]: SHIPPING_RATES_RULES,
  [AbTestTypeCategory.EXTENSIONS]: EXTENSIONS_RULES,
  [AbTestTypeCategory.CROSS_SITE]: CROSS_SITE_RULES,
  [AbTestTypeCategory.PRODUCT_PAGE]: PRODUCT_PAGE_RULES,
};

export const getRulesForTestType = (testType: AbTestTypeCategory): Property[] => {
  return RULES_BY_TEST_TYPE[testType];
};

export const isRuleAvailableForTestType = (testType: AbTestTypeCategory, rule: Property): boolean => {
  return RULES_BY_TEST_TYPE[testType]?.includes(rule) ?? false;
};
